export type Superpack = {
  id: string;
  name: string;
  parent_id: string;
};

export enum SuperpackSortableKeys {
  name = 'name',
}
